<template>
	<div class="existing-integration">
		<div class="existing-integration__label">{{ integration.label }}</div>
		<div class="existing-integration__created">
			<span class="existing-integration__connected">Connected on:</span> {{ createdDate }}
		</div>
		<div class="existing-integration__actions">
			<core-button color="white" size="icon" @click="handleEdit">
				<i class="fa" :class="{ 'fa-pencil': !legacy, 'fa-eye': legacy }" alt="Edit"></i>
			</core-button>
			<core-button v-if="canDelete" color="white" size="icon" @click="handleDelete">
				<i class="fa fa-trash-o" alt="Trash"></i>
			</core-button>
		</div>
	</div>
</template>

<script>
import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';
import { createNamespacedHelpers } from 'vuex';
const { mapState, mapActions } = createNamespacedHelpers('integrations');

export default {
	props: {
		/**
		 * Integration
		 */
		integration: {
			type: Object,
			required: true,
		},
		/**
		 * Whether is legacy.
		 */
		legacy: {
			type: Boolean,
		},
	},
	computed: {
		...mapState(['addingIntegration', 'editingIntegration']),
		/**
		 * Can Delete
		 *
		 * @since 2.4.0
		 *
		 * @returns {boolean} Can the integration be deleted?
		 */
		canDelete() {
			// Can't delete MonsterLeads
			if ('monsterleads' === this.integration.provider) {
				return false;
			}

			return true;
		},
		/**
		 * Created Date
		 *
		 * @since 2.4.0
		 *
		 * @returns {string} The formated date.
		 */
		createdDate() {
			return format(parseISO(this.integration.created_at), 'MM/dd/yyyy');
		},
	},
	methods: {
		...mapActions(['deleteIntegration', 'editIntegration']),
		/**
		 * Handle Edit
		 *
		 * @since 2.4.0
		 *
		 * @returns {void}
		 */
		handleEdit() {
			this.editIntegration(this.integration);
		},
		/**
		 * Handle Delete
		 *
		 * @since 2.4.0
		 *
		 * @returns {void}
		 */
		handleDelete() {
			this.$modal.show(`${this.integration.id}-integrations-delete-modal`);
		},
	},
};
</script>
